<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhoneHorisontal_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M1.361 9.69c-.2-.714-.02-1.534.48-2.195.963-1.273 3.083-2.022 6.32-2.023 3.958 0 5.621 1.1 6.32 2.022.501.66.68 1.48.48 2.195a1.076 1.076 0 0 1-1.304.758l-2.32-.58a1.08 1.08 0 0 1-.82-1.05l-.012-.828a10 10 0 0 0-2.343-.26c-.793-.001-1.552.072-2.318.22l-.037.873c.002.493-.335.925-.82 1.046l-2.32.58a1.08 1.08 0 0 1-1.306-.758"
    />
</svg>
